export const environment = {
  production: false,
  datadogEnv: 'dev',
  domain: 'dev.geloc.latouretpetit.app',
  appVersion: require('../../package.json').version + "-dev",
  posthogKey: 'phc_V5HQIYrlpZgzoSVyra7ozEuwWohyVR76YxsAlaZ0RJz',
  posthogHost: 'https://eu.i.posthog.com',
  posthogProxy: 'https://glo.latouretpetit.link'
};

